<template>
    <span class="label">
        <slot />
    </span>
</template>

<style src="./BaseLabel.less" lang="less"></style>
